import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasAllowedRole } from './roleAccess';

export default function PrivateRoute({ 
  children, 
  requiredArea,
  requiredPermission,
  allowedRoles
}) {
  const { 
    isAuthenticated, 
    loading, 
    hasAccessToArea,
    hasPermission,
    user
  } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 flex items-center justify-center">
        <div className="flex items-center space-x-4 text-white">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          <span className="text-xl font-semibold">Cargando...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasAllowedRole(user, allowedRoles)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requiredArea && !hasAccessToArea(requiredArea)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}